import { useEffect, useState } from 'react'

const MIN = 50
const MAX = 60

const randomInRange = (min: number, max: number) =>
  Math.floor(Math.random() * (max - min + 1)) + min

/**
 * Simulates a live "people viewing" counter that drifts naturally
 * between 50 and 60 every 4-8 seconds.
 */
export function useViewerCount() {
  const [count, setCount] = useState(() => randomInRange(MIN, MAX))

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>

    const schedule = () => {
      timeout = setTimeout(() => {
        setCount((prev) => {
          let next = prev + (Math.random() > 0.5 ? 1 : -1) * randomInRange(1, 3)
          if (next < MIN) next = MIN + randomInRange(0, 2)
          if (next > MAX) next = MAX - randomInRange(0, 2)
          return next
        })
        schedule()
      }, randomInRange(4000, 8000))
    }

    schedule()
    return () => clearTimeout(timeout)
  }, [])

  return count
}
